import React, { Component } from 'react';
import styled from 'styled-components';
import each from 'lodash/each';

import pkg from '../package.json';

import './assets/css/animate.css';

import { getBranding, getAssets } from './helper';

import MainAssetContainer from './containers/MainAssetContainer';

import NoDataMessage from './components/common/NoDataMessage';
import Loader from './components/loader';
import ModalChooser from './components/modalchooser';
import Header from './components/header';

import urlWithParams from './utils/urlWithParams';

const AppVersion = styled.span`
  font-size: 13px;
  color: #ccc;
  font-weight: 100;
  text-transform: uppercase;
  position: fixed;
  bottom: 10px;
  left: 10px;
`;

const MainApp = styled.div`
  ${({ blur }) =>
    blur ? 'filter: blur(4px);' : ''} .ReactModal__Body--open & {
    filter: blur(4px);
  }
`;

class App extends Component {
  constructor(props) {
    super(props);

    const {
      queryParams: { mediaspace = '', sessionKey, ref, logout },
    } = props;

    this.initialAssets = null;

    this.mediaspace = mediaspace;
    this.merchant_uuid = window.location.pathname.replace(/(\/token|\/)/g, '');
    this.referrer = '/channels';

    this.state = {
      isReady: false,
      showFullScreenLoader: true,
      showSuccessfulModal: false,
      isInitialized: false,
      isAuthenticationChecked: false,
      isAuthenticated: false,
      isAccessChecked: false,
      mediaspaceUrl: `https://${mediaspace}`,
    };

    if (sessionKey) {
      window.history.pushState(
        this.state,
        null,
        `${this.merchant_uuid}?mediaspace=${this.mediaspace}`
      );
    }

    if (ref) {
      this.referrer = ref;
    } else if (
      document.referrer &&
      document.referrer !== window.location.href
    ) {
      this.referrer = document.referrer.replace(this.state.mediaspaceUrl, '');
    }

    this.path = `${window.location.pathname}${window.location.search}`;

    //Logout user before paywall init
    if (logout === 'true') {
      window.localStorage.removeItem('inplayer_token');
      window.history.pushState(
        this.state,
        null,
        `${this.merchant_uuid}?mediaspace=${this.mediaspace}`
      );
    }
  }

  async componentDidMount() {
    const {
      queryParams: { id },
    } = this.props;

    const { showFullScreenLoader } = this.state;

    const [branding, assets] = await Promise.all([
      getBranding(this.merchant_uuid),
      getAssets(this.merchant_uuid, this.mediaspace),
    ]);

    this.initialAssets = assets;

    const { collection = [], token } = assets;

    if (showFullScreenLoader) {
      this.setState({
        assets: !id
          ? collection
          : [
              collection.find(
                ({ item: { id: assetId } }) => parseInt(id) === assetId
              ),
            ],
        token: token || false,
        branding,
        showFullScreenLoader: false,
        mediaspaceUrl:
          `https://${this.mediaspace}` +
          (token
            ? urlWithParams(`/user/authenticate/sessionKey/${token}`, {
                ref: this.referrer,
              })
            : ''),
      });
    } else {
      this.readyForPaywall();
    }

    document.body.className = '';
  }

  componentDidUpdate(
    {
      languages: { language: prevLang },
    },
    { isReady: wasReady, showFullScreenLoader: didShowFullScreenLoader }
  ) {
    const {
      languages: { language },
    } = this.props;

    const { isReady, showFullScreenLoader } = this.state;

    if (language !== prevLang) {
      this.setPaywallLanguage(language);
    }

    if (isReady && !wasReady) {
      this.popupPaywall();
    }

    if (didShowFullScreenLoader && !showFullScreenLoader) {
      this.readyForPaywall();
    }
  }

  readyForPaywall = () => {
    const {
      queryParams: { id, login },
    } = this.props;

    const { collection = [], token } = this.initialAssets;

    this.initPaywall(collection);

    if (id && login === 'true') {
      each(collection, (asset) => {
        const {
          item: { id: currentId },
          has_access: hasAccess,
        } = asset;

        if (Number(currentId) === Number(id)) {
          if (hasAccess) {
            window.location.href = urlWithParams(
              `https://${
                this.mediaspace
              }/user/authenticate/sessionKey/${token}`,
              { ref: this.referrer }
            );
          } else {
            this.showPaywall(asset, token)();
          }

          return false;
        }
      });
    }
  };

  singleAssetRedirect(collection, token) {
    const {
      queryParams: { screen },
    } = this.props;
    if (
      screen !== 'myaccount' &&
      collection &&
      collection.length === 1 &&
      collection[0].has_access === true
    ) {
      window.location.href = urlWithParams(
        `https://${this.mediaspace}/user/authenticate/sessionKey/${token}`,
        { ref: this.referrer }
      );
    }
  }

  initPaywallEvents() {
    const {
      queryParams: { id },
    } = this.props;

    this.paywall.on('init', ({ data: { isAuthenticated } }) => {
      const { isAccessChecked } = this.state;

      const newState = {
        isInitialized: true,
      };

      if (!isAuthenticated) {
        Object.assign(newState, {
          isAuthenticationChecked: true,
          isReady: isAccessChecked,
        });
      }

      this.setState(newState);
    });

    this.paywall.on('access', () => {
      const { isAuthenticationChecked } = this.state;

      this.setState({
        isAccessChecked: true,
        isReady: isAuthenticationChecked,
      });

      this.singleAssetRedirect(this.state.assets, this.state.token);
    });

    this.paywall.on('authenticated', async () => {
      let assets = await getAssets(this.merchant_uuid, this.mediaspace);

      const { isAccessChecked } = this.state;
      const { token, collection = [] } = assets;
      this.singleAssetRedirect(collection, token);
      this.setState({
        assets: !id
          ? collection
          : [
              collection.find(
                ({ item: { id: assetId } }) => parseInt(id) === assetId
              ),
            ],
        token: token || false,
        showFullScreenLoader: false,
        showSuccessfulModal: false,
        isAuthenticationChecked: true,
        isAuthenticated: true,
        isReady: isAccessChecked,
        mediaspaceUrl:
          `https://${this.mediaspace}` +
          (token
            ? urlWithParams(`/user/authenticate/sessionKey/${token}`, {
                ref: this.referrer,
              })
            : ''),
      });
    });

    this.paywall.on('logout', () => {
      this.setState({
        showFullScreenLoader: true,
        isAuthenticated: false,
      });

      window.location.href = `https://${this.mediaspace}/user/logout`;
    });

    this.paywall.on('access.granted', async () => {
      let assets = await getAssets(this.merchant_uuid, this.mediaspace);

      const { token, collection = [] } = assets;

      this.setState({
        assets: !id
          ? collection
          : [
              collection.find(
                ({ item: { id: assetId } }) => parseInt(id) === assetId
              ),
            ],
        token: token || false,
        showFullScreenLoader: false,
        showSuccessfulModal: collection.length > 1 ? true : false,
        mediaspaceUrl:
          `https://${this.mediaspace}` +
          (token
            ? urlWithParams(`/user/authenticate/sessionKey/${token}`, {
                ref: this.referrer,
              })
            : ''),
      });

      this.singleAssetRedirect(collection, token);
    });

    this.paywall.on('language', ({ data: { language } }) => {
      const actualLanguage = this.setOwnLanguage(language);

      if (actualLanguage !== language) {
        this.setPaywallLanguage(actualLanguage);
      }
    });
  }

  setOwnLanguage = (lang) => {
    const {
      languages: { setLanguage: setOwnLanguage },
    } = this.props;

    return setOwnLanguage(lang);
  };

  setPaywallLanguage = (lang) => {
    if (this.paywall) {
      this.paywall.setLanguage(lang);
    }
  };

  closeModal = () => {
    document.body.className = '';
    this.setState({ showSuccessfulModal: false, showFullScreenLoader: false });
  };

  showPaywall = (
    { item: { id: assetId }, has_access: hasAccess, mediaspace },
    token
  ) => () => {
    if (hasAccess) {
      this.setState({ token, showFullScreenLoader: true });
      window.location.href = urlWithParams(
        `https://${mediaspace}/user/authenticate/sessionKey/${token}`,
        { ref: this.referrer }
      );
    } else {
      this.paywall.showPaywall({
        asset: { assetId },
        options: { noPreview: true, noInject: true },
      });
    }
  };

  showMyAccount = () => {
    this.paywall.showMyAccount();
  };

  initPaywall(items) {
    const {
      queryParams: { id },
      languages: { language },
    } = this.props;

    const { InplayerPaywall } = window;

    if (!InplayerPaywall || !this.merchant_uuid) {
      return;
    }

    const paywallItems = items.reduce((acc, asset) => {
      const {
        item: { id: currentId },
      } = asset;

      if (id && Number(currentId) !== Number(id)) {
        return acc;
      }

      return [
        ...acc,
        {
          id: currentId,
          options: { noPreview: true, noInject: true },
        },
      ];
    }, []);

    this.paywall = new InplayerPaywall(this.merchant_uuid, paywallItems, {
      language,
    });

    this.initPaywallEvents();
  }

  popupPaywall = () => {
    const {
      queryParams: { screen, id },
    } = this.props;

    const { isAuthenticated, token, assets } = this.state;

    if (screen === 'myaccount' && isAuthenticated) {
      this.showMyAccount();
    } else if (id) {
      this.showPaywall(assets[0], token)();
    }
  };

  render() {
    const {
      assets = [],
      showFullScreenLoader,
      showSuccessfulModal,
      mediaspaceUrl,
      branding,
      isAuthenticated,
      token,
    } = this.state;

    const {
      queryParams: { id },
      languages,
      languages: { translate },
    } = this.props;

    if (showFullScreenLoader) {
      return <Loader translate={translate}>{translate('please_wait')}</Loader>;
    }

    return (
      <>
        <MainApp blur={showSuccessfulModal}>
          <Header
            mediaspace={mediaspaceUrl}
            branding={branding}
            isAuthenticated={isAuthenticated}
            mediaspaceUrl={this.mediaspace}
            languages={languages}
          />
          {assets.length ? (
            <MainAssetContainer
              id={id}
              assets={assets}
              branding={branding}
              token={token}
              translate={translate}
              showPaywall={this.showPaywall}
            />
          ) : (
            <NoDataMessage>
              {translate('your_kaltura_item_list_is_empty')}
            </NoDataMessage>
          )}
        </MainApp>
        {showSuccessfulModal && (
          <ModalChooser
            referrer={this.referrer}
            branding={branding}
            mediaspaceUrl={mediaspaceUrl}
            closeModal={this.closeModal}
            translate={translate}
          />
        )}
        <AppVersion>version {pkg.version}</AppVersion>
      </>
    );
  }
}

export default App;
